<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-content-container">
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div class="page-content-header-item">
                            制定学习计划 <span class="fh" @click="handleBack">
                                返回 </span>
                        </div>
                    </div>
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <div class="page-tips-container">
                                <div v-for="(item, index) in tipsData" :key="'tips-' + index" class="page-tips-item-wrapper"
                                    @click="handleTips(item)">
                                    <div v-if="index == 0" class="tips-img-wrapper">
                                        <img v-if="activeTips == item.id" src="@/assets/img/rect1.png" alt=""
                                            class="tips-img">
                                        <img v-else src="@/assets/img/rect6.png" alt="" class="tips-img">
                                    </div>
                                    <div v-else-if="index == tipsData.length - 1" class="tips-img-wrapper">
                                        <img v-if="activeTips == item.id" src="@/assets/img/rect5.png" alt=""
                                            class="tips-img">
                                        <img v-else src="@/assets/img/rect4.png" alt="" class="tips-img">
                                    </div>
                                    <div v-else class="tips-img-wrapper">
                                        <img v-if="activeTips == item.id" src="@/assets/img/rect3.png" alt=""
                                            class="tips-img">
                                        <img v-else src="@/assets/img/rect2.png" alt="" class="tips-img">
                                    </div>
                                    <div class="tips-item-content">
                                        {{ item.label }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="activeTips == 'basic-info'">
                                <BasicInfo @step="getSetp"></BasicInfo>
                            </div>
                            <div v-if="activeTips == 'select-class'">
                                <SelectClass @step="getSetp"></SelectClass>
                            </div>
                            <div v-if="activeTips == 'add-test'">
                                <AddTest @step="getSetp"></AddTest>
                            </div>
                            <div v-if="activeTips == 'add-measure'">
                                <AddMeasure @step="getSetp"></AddMeasure>
                            </div>
                            <div v-if="activeTips == 'add-member'">
                                <AddMember @step="getSetp"></AddMember>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import BasicInfo from './components/BasicInfo.vue'
import SelectClass from './components/SelectClass.vue'
import AddTest from './components/AddTest.vue'
import AddMeasure from './components/AddMeasure.vue'
import AddMember from './components/AddMember.vue'
export default {
    name: '',
    components: {
        Header,
        BasicInfo,
        SelectClass,
        AddTest,
        AddMeasure,
        AddMember
    },
    data() {
        return {
            tipsData: [
                {
                    id: "basic-info",
                    label: "1.基本信息"
                },
                {
                    id: "select-class",
                    label: "2.选择课程"
                },
                {
                    id: "add-test",
                    label: "3.添加阶段测试"
                },
                {
                    id: "add-measure",
                    label: "4.添加综合测评"
                },
                {
                    id: "add-member",
                    label: "5.添加学习人员"
                }
            ],
            activeTips: 'basic-info'
        }
    },
    mounted() {
        scrollTo(0, 0);
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        handleTips(row) {
            this.activeTips = row.id;
        },
        getSetp(params) {
            this.activeTips = params;
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
}

.fh {
    cursor: pointer;
    font-size: 19px;
    color: #ccc;
    margin-left: 50px;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-header {
    width: 100%;
    height: 80px;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
    display: flex;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 300px;
    height: 100%;
    text-align: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
}

.page-content-wrapper {
    display: flex;
}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
}

.page-tips-container {
    width: 1100px;
    /* background: red; */
    display: flex;
    justify-content: space-between;
}

.page-tips-item-wrapper {
    flex: 1;
    position: relative;
    cursor: pointer;
}

.tips-img-wrapper {
    width: 100%;
    height: 100%;
}

.tips-img {
    width: 100%;
    height: 100%;
}

.tips-item-content {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    position: absolute;
    top: 0px;
    left: 0px;
}
</style>


